module.exports = __webpack_public_path__ + "img/cross_pop.a4c70038.svg";